import dayjs from 'dayjs'
import store from 'app/store'

const formatter = {
  date: (value: any = new Date(), pattern = 'L') => dayjs(value).format(pattern),
  unit: (value: any, unit: string) => `${value}${unit}`,
  currency: (value: number = 0) => {
    const locale = store.getState().locale.locale || 'hu'
    const currency = locale === 'hu' ? 'Ft' : 'HUF'
    const formatted = new Intl.NumberFormat('hu').format(value)

    return `${formatted} ${currency}`
  },
  amountFromMinor: (totalAmount: number | string = 0, amountWithSign: number = 0) => {
    if (totalAmount === null || totalAmount === undefined) return '0'
    var sign = amountWithSign < 0 ? '-' : ''
    const locale = store.getState().locale.locale || 'hu'

    let num = Number(totalAmount)
    if (Number.isNaN(num)) return '0'

    num = num / 100

    const formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: num % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(num)

    return `${sign}${formatted}`
  }
}

export default formatter
